export default function loginLinks({ forgotYourPasswordAction, defaults, domainInfo }) {
    return {
        links: {
            ...(domainInfo.supportEmailEnabled && {
                contact_support: `mailto:${domainInfo.supportEmail || defaults.SUPPORT_EMAIL}`,
            }),
            ...(forgotYourPasswordAction && {
                forgot_your_password: forgotYourPasswordAction,
            }),
        },
        ...(domainInfo.termsUrlEnabled && {
            termsAndConditionsLink:
        domainInfo.termsUrl || domainInfo.termsAndConditionsLink || defaults.TERMS_URL,
        }),
    };
}
